
import { Ref, ref } from 'vue';
import { useStore } from 'vuex';
import { onClickOutside } from '@vueuse/core';

export default {
  name: 'Modal',
  props: {
    title: String,
    subTitle: String,
  },
  setup(): {
    closeModal: () => void;
    modal: Ref<HTMLDivElement | null>;
  } {
    const store = useStore();
    const closeModal = (): void => {
      store.dispatch('ui/toggleModalStatus');
    };

    const modal: Ref<HTMLDivElement | null> = ref(null);
    onClickOutside(modal, () => closeModal());

    return {
      closeModal,
      modal,
    };
  },
};
